import {createStore} from 'redux';
import mainReducer from './reducers/mainReducer';

const mainStore = createStore(mainReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
export default mainStore;